export enum GlobalFarmMetric {
  'Governance' = 0,
  'Air & Climate' = 1,
  'Soil' = 2,
  'Water' = 3,
  'Biodiversity' = 4,
  'Land Use' = 5,
  'Crops & Pasture' = 6,
  'Livestock' = 7,
  'Farmers & Workers' = 8,
  'Agricultural Supplies' = 9,
  'Community' = 10,
  'Economics' = 11,
}

export enum MeasurementStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
}

export enum BuyerOrgInitiative {
  BBF = 'BBF',
  FFL = 'FFL',
  SAAS = 'SaaS',
}

export enum OrganizationSize {
    Micro = 'micro',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
    Unknown = 'unknown'
}
